document.addEventListener('DOMContentLoaded', function () {
  const css = '.message-prompt { display: none !important; } .signUp-button { display: none !important; }';

  function injectStyles(shadowRoot) {
    if (shadowRoot.querySelector('[data-hide-chat-elements]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-hide-chat-elements', 'true');
    style.textContent = css;
    shadowRoot.appendChild(style);
  }

  function tryInject() {
    const chat = document.querySelector('#shopify-chat inbox-online-store-chat');
    if (chat && chat.shadowRoot) {
      injectStyles(chat.shadowRoot);
      return true;
    }
    return false;
  }

  if (tryInject()) return;

  const observer = new MutationObserver(function () {
    if (tryInject()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function () {
    observer.disconnect();
  }, 4000);
});
